import { log } from './log';

export function startSuspendingCommit()
{
    log('info', 'lifecycle::startSuspendingCommit');
}
